__turbopack_context__.v({
  "container": "IB_kzG_container",
});
